
export default function company( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_COMPANY':
			return action.company
		case 'GET_COMPANY':
			return action.company
		case 'DELETE_COMPANY':
			return action.company
		case 'GET_BY_ID_COMPANY':
			return action.company
		case 'EDIT_COMPANY':
			return action.company
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/company/company.reducer.js